// Services data - AI solutions offered by NAIRDC
export const services = [
  {
    id: 1,
    title: "AI Chatbot",
    desc: "Transform user experiences with our advanced chatbots and interactive systems. Utilizing modern tech, we streamline departmental processes seamlessly.",
    videoKey: "chatbotVid",
    iconKey: "chatBot",
  },
  {
    id: 2,
    title: "Smart Dashboards",
    desc: "Improve your operations with smart dashboards powered by AI, our solutions streamline control and monitoring. Gain real-time insights and visualizations for informed decisions and peak efficiency.",
    videoKey: "dashboardVid",
    iconKey: "dashboard",
  },
  {
    id: 3,
    title: "Predictive Analytics Solutions",
    desc: "Empower your decisions with our predictive analytics solutions, uncover insights from historical data using advanced algorithms and machine learning.",
    videoKey: "predictionandforecastingVid",
    iconKey: "predictionForecasting",
  },
  {
    id: 4,
    title: "Computer Vision Solutions",
    desc: "Giving your systems an intelligent eye will help in recognizing images or detecting objects.",
    videoKey: "computerVisionVid",
    iconKey: "computerVision",
  },
  {
    id: 5,
    title: "ML Platform (Machine Learning)",
    desc: "Empower your business with our smart platforms. We customize machine learning and AI, putting powerful tools in your hands. Train your data with ease and unlock endless possibilities.",
    videoKey: "blockchainVid",
    iconKey: "blockchain",
  },
  {
    id: 6,
    title: "Generative AI",
    desc: "Our technology amplifies human creativity, generating unique content at one click. Experience the power of AI, unlock new possibilities.",
    videoKey: "ocrVid",
    iconKey: "ocr",
  },
  {
    id: 7,
    title: "AI-Enabled ERP Development",
    desc: "Unlock operational efficiency and strategic insights through AI-driven analytics, forecasting, and automation with ERP Advance solution.",
    videoKey: "iotVid",
    iconKey: "iot",
  },
  {
    id: 8,
    title: "Robotic Process Automation (RPA)",
    desc: "Business growth begins with our technology and solutions handling repetitive tasks. Our solutions elevate speed, accuracy, and efficiency in critical processes such as contract auditing, invoicing, and salary management.",
    videoKey: "rpaVid",
    iconKey: "rpa",
  },
  {
    id: 9,
    title: "Large Language Model (LLM)",
    desc: "Tailoring LLM systems bring domain-specific expertise to your fingertips. From summarizing documents to analyzing reports and classifying data, our LLM solutions are poised to transform your business.",
    videoKey: "dataAnalyticsVid",
    iconKey: "dataAnalytics",
  },
  {
    id: 10,
    title: "Personalized Training Recommendations",
    desc: "Boost your team's skills with custom training. Our smart system analyzes each employee's strengths and goals to offer personalized development plans.",
    videoKey: "recosystemVid",
    iconKey: "recommendationSystem",
  },
];

// Service card layout configuration (which cards appear on left vs right)
export const serviceCardLayout = {
  left: [
    { id: 9, iconKey: "dataAnalytics", title: "Large Language Model" },
    { id: 5, iconKey: "blockchain", title: "Machine Learning Platform" },
    { id: 7, iconKey: "iot", title: "AI-Enabled ERP Development" },
    { id: 6, iconKey: "ocr", title: "Generative AI" },
    { id: 10, iconKey: "recommendationSystem", title: "Personalized Training Recommendations" },
  ],
  right: [
    { id: 1, iconKey: "chatBot", title: "AI Chatbot" },
    { id: 2, iconKey: "dashboard", title: "Smart Dashboards" },
    { id: 3, iconKey: "predictionForecasting", title: "Predictive Analytics Solutions" },
    { id: 4, iconKey: "computerVision", title: "Computer Vision Solutions" },
    { id: 8, iconKey: "rpa", title: "Robotic Process Automation" },
  ],
};
